import { AxiosResponse } from 'axios';
import { environment } from '../../../environments/environment';
import { ConnectStore } from '../stores/auth.store';
import { EndpointHelper } from './endpoint.helper';
import { HttpClient } from './http';
import { StorageHelper } from './storage';

export class AuthService {

  static authorizeUser(bodyObject: any): Promise<any> {
    return HttpClient.GetInstance.post<any, any>(`${environment.UMBRACO_CONNECT_URL}/signIn`, bodyObject)
      .then(
        (res: AxiosResponse<any>) => {
          try {
            return res?.data;
          } catch (err) {
            Promise.reject(err)
          }
        },
        (err) => {
          console.log('Inner Sign-in Request err-> ', err);
          throw new Error(err);
        }
      );
  }

  static signUp(path: string) {
    const redirectURL = `${window.location.origin}${window.location.pathname}#${path}`;
    const builder = new EndpointHelper(`${environment.CONNECT_URL}`)
      .createUrl('signup')
      .addQueryParamUrl('redirect_uri', redirectURL) // .replace('http://localhost:3000', 'https://unificationdev.azurewebsites.net'))
      .addQueryParam('client_id', environment.CONNECT_CLIENT_ID)
      .addQueryParam('bypasslinking', true)
      .addQueryParam('show_bc', false)
      .addQueryParam('nomobile', true)
      .addQueryParam('usejwt', `${environment.USE_CONNECT_JWT}`);

    const url = builder.build();
    window.location.assign(url);
  }

  static signIn(path: string) {
    const redirectURL = `${window.location.origin}${window.location.pathname}#/${path}`;
    const builder = new EndpointHelper(`${environment.CONNECT_URL}`)
      .createUrl('signin')
      .addQueryParamUrl('redirect_uri', redirectURL) // .replace('http://localhost:3000', 'https://unificationdev.azurewebsites.net'))
      .addQueryParam('client_id', environment.CONNECT_CLIENT_ID)
      .addQueryParam('bypasslinking', true)
      .addQueryParam('show_bc', false)
      .addQueryParam('nomobile', true)
      .addQueryParam('usejwt', `${environment.USE_CONNECT_JWT}`);

    const url = builder.build();
    window.location.assign(url);
  }

  static logout() {
    StorageHelper.GetInstance.removeFromStorage('conf');
  }

  static refreshToken(connectStore: ConnectStore) {
    if (!connectStore) {
      return Promise.reject('Unable to refresh token');
    }

    const { access_token, expires_in, id_token, token_type, expires_time } = connectStore;

    return HttpClient.GetInstance.post<any, any>(`${environment.UMBRACO_CONNECT_URL}/sessionRefresh`, {
      accessToken: access_token,
      expiresIn: expires_in,
      idToken: id_token,
      tokenType: token_type,
      expiresTime: expires_time,
    })
      .then((res: any) => {
        try {
          const { accesstoken, idtoken } = res?.data;
          const parsedAccessToken = this.parseJwt(accesstoken);
          const data = {
            ...connectStore,
            // customerNumber: CustomerNumber,
            access_token: accesstoken,
            id_token: idtoken,
            expiry: parsedAccessToken.exp,
            valid: !!accesstoken ? true : false,
            message: 'Id token valid'
          };

          if (!data.access_token?.length) {
            return Promise.reject({ valid: false, message: 'Unauthenticated customer status' });
          }

          localStorage.setItem('connect-store', JSON.stringify(data))
          return data;

        } catch (err) {
          return Promise.reject({ valid: false, message: 'Failed to parse customer' });
        }
      });
  }

  static parseJwt(token: string = '') {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
  }
}
